import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";

const AppInstallBanner = ({ setShowInstallPopup }) => {
  return (
    <div className={styles["appinstall-banner"]}>
      <a href="https://onelink.to/et7zcx" className={styles["appinstallbanner-link"]}>
        <div className={styles["banner-content"]}>
          <div className={styles["qr-section"]}>
            <img src="https://media.vikatan.com/vikatan/2025-11-15/e4zz1tvr/app-mobile2x.png" alt="Mobile" />
          </div>

          <div className={styles["features"]}>
            <div className={styles["feature"]}>
              <img src="https://media.vikatan.com/vikatan/2025-11-15/izl3s7wy/Rate.png" alt="" />
              <span>4.7 / 5 Rating</span>
            </div>
            <div className={styles["feature"]}>
              <img src="https://media.vikatan.com/vikatan/2025-11-15/0uzg9nj2/Download.png" alt="" />
              <span>3.5M+ Downloads</span>
            </div>
            <div className={styles["feature"]}>
              <img src="https://media.vikatan.com/vikatan/2025-11-15/atlzz0fj/Audi.png" alt="" />
              <span>Audio Magazines</span>
            </div>
            <div className={styles["feature"]}>
              <img src="https://media.vikatan.com/vikatan/2025-11-15/qh1n2w91/News.png" alt="" />
              <span>Instant News Summary</span>
            </div>
            <div className={styles["feature"]}>
              <img src="https://media.vikatan.com/vikatan/2025-11-15/01u539xp/Audiobook.png" alt="" />
              <span>Free 500+ Audio Books</span>
            </div>
            <div className={styles["feature"]}>
              <img src="https://media.vikatan.com/vikatan/2025-11-15/pyiuccpg/Data.png" alt="" />
              <span>Low Data Usage</span>
            </div>
          </div>

          <div className={`${styles["store-links"]} hidden-mobile`}>
            <div>
              <img src="https://media.vikatan.com/vikatan/2025-11-15/yhf5n3fv/Applestore.png" alt="App Store" />
            </div>
            <div>
              <img src="https://media.vikatan.com/vikatan/2025-11-18/u7swfs9e/PlayStoreicon.png" alt="Play Store" />
            </div>
          </div>
        </div>

        <div className={styles["cta-grid"]}>
          <div className={styles["cta"]}>
            <span className={styles["mobile-hide-text"]}>INSTALL APP &amp; </span>
            <span className={styles["mobile-break"]}>GET 30 DAYS FREE TRIAL</span>
          </div>
          <div className={styles["mobile-store-section"]}>
            <div className={`${styles["store-links"]} hidden-desktop`}>
              <div>
                <img src="https://media.vikatan.com/vikatan/2025-11-15/yhf5n3fv/Applestore.png" alt="App Store" />
              </div>
              <div>
                <img src="https://media.vikatan.com/vikatan/2025-11-15/kq0kxvxq/Playstore.png" alt="Play Store" />
              </div>
            </div>
            <div className={styles["install-app-text"]}>Install App</div>
          </div>
        </div>
      </a>
    </div>
  );
};

AppInstallBanner.propTypes = {
  setShowInstallPopup: PropTypes.func.isRequired
};

export default AppInstallBanner;
